var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRevitalizingRural(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10",
    "data-name": "Group 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 81.436,
    height: 102.263,
    viewBox: "0 0 81.436 102.263",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 81.436,
    height: 102.263,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M38.122,267.473C17.648,266.42-.51,247.781.011,227.028a1.662,1.662,0,0,1,1.854-1.7h77.7a1.662,1.662,0,0,1,1.854,1.7c.527,20.991-17.611,39.153-38.111,40.446ZM17.352,228.331H2.974a38.152,38.152,0,0,0,11.083,25.159,28.675,28.675,0,0,1,6.887-4.8,67.178,67.178,0,0,1-3.592-20.361m21.968,0H20.348a58.939,58.939,0,0,0,3.2,18.972,38.529,38.529,0,0,1,15.773-3.795Zm21.767,0H42.116v15.177a40.316,40.316,0,0,1,11.49,1.99c1.128.367,2.685,1.266,3.684,1.52s1.241-1.641,1.5-2.512a59.957,59.957,0,0,0,2.3-16.176m17.374,0H64.083a67.887,67.887,0,0,1-3.592,20.361,28.673,28.673,0,0,1,6.887,4.8,38.151,38.151,0,0,0,11.084-25.159M39.32,246.5a33.672,33.672,0,0,0-14.595,3.518c2.452,6.446,7.32,13.273,14.595,14.456Zm2.8,17.973c5.03-.729,8.89-4.406,11.588-8.482.595-.9,3.007-4.993,2.985-5.81-.014-.527-2.195-1.231-2.741-1.435A34.4,34.4,0,0,0,42.116,246.5Zm-12.382-1.6A35.666,35.666,0,0,1,22.142,251.3a27.373,27.373,0,0,0-5.774,4.121c-.049.277,1.822,1.676,2.2,1.953a38.2,38.2,0,0,0,11.166,5.507m35.547-7.583-5.988-4A36.137,36.137,0,0,1,51.7,262.878a34.457,34.457,0,0,0,13.58-7.583",
    transform: "translate(0 -165.21)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M225.392,41.282l9.138-.038,1.062,1.135.051,42.3a1.672,1.672,0,0,1-1.113,1.683c-2.743-.285-6.335.408-8.969-.007a1.167,1.167,0,0,1-1.068-.929l-.052-42.7a1.28,1.28,0,0,1,.951-1.446m7.246,2.753h-5.093l-.3.3V83.277l.3.3h5.093Z",
    transform: "translate(-164.562 -30.24)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M163.471,89.187l8.939-.039,1.062.935.045,30.118a1.212,1.212,0,0,1-.945,1.252l-9.138.038-1.062-1.135-.05-29.322c.018-.8.279-1.654,1.149-1.846m1.854,29.513h5.093l.3-.3V92.239l-.3-.3h-5.093Z",
    transform: "translate(-119.016 -65.364)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M92.624,5.607,56.53,33.317c-1.71.454-2.7-1.065-1.632-2.431L90.428,3.509c-1.886-.327-4-.225-5.873-.515C82.347,2.65,82.365-.089,84.941,0c2.709.1,6.485.447,9.183.811,1.536.207,1.764.827,1.706,2.3a83.387,83.387,0,0,1-.855,9.332,1.465,1.465,0,0,1-2.8.5c-.277-2.376.387-4.92.446-7.339",
    transform: "translate(-39.926 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M101.882,124.812c2.755.16,6.063-.356,8.75-.046,1.2.139,1.4.811,1.5,1.894.572,6.14-.447,13.15,0,19.383a1.754,1.754,0,0,1-.944,1.452c-2.812-.168-6.208.368-8.949.045-.57-.067-.994-.212-1.206-.791l-.1-20.691c.009-.572.507-.966.951-1.246m7.248,2.954h-5.392v16.675l.3.3h5.093Z",
    transform: "translate(-74.004 -91.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M39.515,165.234c2.683.157,5.936-.358,8.549-.047a1.531,1.531,0,0,1,1.5,1.292,64.023,64.023,0,0,1,0,9.206c-.088.964-.264,1.37-1.3,1.492a58.619,58.619,0,0,1-8.6.006,1.53,1.53,0,0,1-1.293-1.5,61.023,61.023,0,0,1,0-9,1.53,1.53,0,0,1,1.145-1.451m7.247,2.953H41.369v6.191h5.093l.3-.3Z",
    transform: "translate(-28.011 -121.042)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevitalizingRural);
export default __webpack_public_path__ + "static/media/revitalizing_rural.f2c32b53c5f971df5cc71454adf08063.svg";
export { ForwardRef as ReactComponent };